import {ModulePages} from "../../core/module-pages";
import {DashboardIndex} from "./pages";

export function DashboardModule() {
  return (
    <ModulePages routes={[
      { path: '' , render: (props) => <DashboardIndex {...props} />}
    ]}/>
  )
}